import { GlIcon, GlLink } from '@gitlab/ui';
import { __, s__ } from '~/locale';
import ClipboardButton from '~/vue_shared/components/clipboard_button.vue';
export default {
    name: 'PublishMethod',
    components: {
        ClipboardButton,
        GlIcon,
        GlLink
    },
    props: {
        pipeline: {
            type: Object,
            required: false,
            default: null
        }
    },
    computed: {
        hasPipeline () {
            return Boolean(this.pipeline);
        },
        packageShaShort () {
            return this.pipeline?.sha?.substring(0, 8);
        }
    },
    i18n: {
        COPY_COMMIT_SHA: __('Copy commit SHA'),
        MANUALLY_PUBLISHED: s__('PackageRegistry|Manually published')
    }
};
